import React from 'react';

import { useSelector } from 'react-redux';

import { Alert, Box } from '@mui/material';

import { getCreditRefundFrequencyMessage } from '~/consts/refund';

import { useGetCreditRefundFrequency } from '~/hooks/apis/orders/useGetCreditRefundFrequency';
import { useGetUser } from '~/hooks/apis/users/useGetUser';

interface Props {
  userId: string;
}

/**
 * Warns that this customer has hit the rolling-window limit on self-service refunds to
 * credit, so those refunds are now blocked in the Customer Portal (credit cycling).
 */
export default function CreditRefundAlert({ userId }: Props) {
  const tenant = useSelector((state: App.State) => state.tenant);

  // First, fetch the user to get id_member
  const { data: user } = useGetUser({ userId, brand: tenant.brand });

  const { data: creditRefundResponse } = useGetCreditRefundFrequency(user?.id_member, !!user?.id_member);
  const creditRefunds = creditRefundResponse?.result;

  // Only surfaced once the customer is actually blocked
  if (!creditRefunds?.blocked) {
    return null;
  }

  return (
    <Box sx={{ mb: 4 }}>
      <Alert severity="warning">
        {getCreditRefundFrequencyMessage(creditRefunds.count, creditRefunds.window_days, creditRefunds.threshold)}
      </Alert>
    </Box>
  );
}
